import { Add, Delete, Watch } from "@mui/icons-material";
import {
  Button,
  Card,
  CardContent,
  Grid2,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import FormTextField from "../../../../component/form/FormTextField";
import FormTimePicker from "../../../../component/form/FormTimePicker";
import FormToggleButtonGroup from "../../../../component/form/FormToggleButtonGroup";

export default function VisitingHours({ control, setValue }) {
  const theme = useTheme();
  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: `visitingHours`, // unique name for your Field Array
  });

  // inside VisitingHours
  const timeSlot0 = useWatch({
    control,
    name: "visitingHours.0.timeSlot",
  });

  useEffect(() => {
    if (timeSlot0 !== undefined) {
      fields.forEach((_, idx) => {
        if (idx > 0) {
          setValue(`visitingHours.${idx}.timeSlot`, timeSlot0);
        }
      });
    }
  }, [timeSlot0, fields, control]);
  useEffect(() => {
    if (fields.length === 0) {
      append();
    }
  }, [fields.length, append]);

  return (
    <Card
      sx={{
        boxShadow: "none",
        // p: "0px !important",
        // border: `1px solid ${theme.palette.secondary.main}`, // primary color border
        // borderRadius: 3,
      }}
    >
      <Stack
        direction={"row"}
        justifyContent="space-between"
        alignItems={"center"}
        sx={{
          bgcolor: "primary.light",
          //   borderBottom:
          //     fields?.length > 0
          //       ? `1px solid ${theme.palette.secondary.main}`
          //       : "none",
          //   pb: 2,
          px: 2,
          py: 1,
        }}
      >
        <Typography fontWeight={500} variant="h6" color="primary">
          Visiting Hours
        </Typography>
        {/* <Button
          startIcon={<Add />}
          variant="contained"
          color="primary"
          size="small"
          onClick={() =>
            append({
              hospital: "",
              address: "",
              weekDays: [],
            })
          }
        >
          Add Visiting Hours
        </Button> */}
      </Stack>
      {fields?.length > 0 && (
        <CardContent sx={{ px: 0, pt: 1, pb: 0 }}>
          {fields.map((item, index) => (
            // <Card
            //   variant="outlined"
            //   sx={{
            //     mb: 2,
            //     p: 2,
            //     borderRadius: 2,
            //     boxShadow: 1,
            //   }}
            //   key={item.id}
            // >
            <Grid2 container spacing={2} key={item.id}>
              {/* Hospital */}
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <FormTextField
                  placeholder="Hospital Name"
                  label="Hospital Name"
                  fieldname={`visitingHours.${index}.hospital`}
                  control={control}
                  required
                  onlyText
                />
              </Grid2>

              {/* Address */}
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <FormTextField
                  placeholder="Address"
                  label="Address"
                  fieldname={`visitingHours.${index}.address`}
                  control={control}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <FormTimePicker
                  control={control}
                  fieldname={`visitingHours.${index}.from`}
                  label="Start Time"
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <FormTimePicker
                  control={control}
                  fieldname={`visitingHours.${index}.to`}
                  label="End Time"
                  required
                />
              </Grid2>

              {/* Days */}
              <Grid2 size={{ xs: 12 }}>
                <FormToggleButtonGroup
                  fieldname={`visitingHours.${index}.weekDays`}
                  control={control}
                  label="Select Days"
                  required
                  exclusive={false}
                  options={[
                    { value: 1, label: "Monday" },
                    { value: 2, label: "Tuesday" },
                    { value: 3, label: "Wednesday" },
                    { value: 4, label: "Thursday" },
                    { value: 5, label: "Friday" },
                    { value: 6, label: "Saturday" },
                  ]}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <FormTextField
                  placeholder="Time slot in minutes"
                  label="Time slot (in minutes)"
                  fieldname={`visitingHours.${index}.timeSlot`}
                  control={control}
                  disabled={index > 0 ? true : false}
                  required
                  type="number"
                />
              </Grid2>

              {/* Delete */}

              {/* <Grid2 size={{ xs: 12 }}>
                  <Button
                    startIcon={<Delete />}
                    variant="contained"
                    color="error"
                    disabled={index === 0}
                    onClick={() => remove(index)}
                  >
                    Delete
                  </Button>
                </Grid2> */}
            </Grid2>
            // </Card>
          ))}
        </CardContent>
      )}
    </Card>
  );
}
